package one.healthium.paywall.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.paywall.ui.PaywallScreen

@Composable
fun PaywallContent(
    component: PaywallComponent
) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        PaywallScreen(
            paywallId = component.paywallId,
            eventDelegate = component,
        )
    }
}